export default {
  SET_users(state, value) {
    state.users = value;
  },
};
